/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { TextBox, useDirection } from '@veneer/core';
import './styles.scss';
import { TextFieldProps } from './types';
import { withAnalytics } from '@veneer/analytics';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit TextField component based on Veneer TextBox
 * @public
 */
const TTextField: React.FC<TextFieldProps> = (props) => {
  const rtl = useDirection().isRTL;

  const {
    supportiveText,
    id = generateID('clientos-ui-toolkit-text-field'),
    ...rest
  } = props;
  const addClass = (): string => {
    if (props.error) {
      return 'clientos-ui-toolkit-text-field--has-error';
    }
    if (props.disabled) {
      return 'clientos-ui-toolkit-text-field--disabled';
    }
    if (rtl) {
      return 'rtl';
    }
    return '';
  };

  return (
    <div
      className={`clientos-ui-toolkit-text-field ${addClass()}`}
      id={id}
    >
      <TextBox
        className="box"
        id={`${id}__text-box`}
        {...rest}
      />
      <p
        className="clientos-ui-toolkit-text-field__supportive-text"
        id={`${id}__supportive-text`}
      >
        {supportiveText}
      </p>
    </div>
  );
};

export const TextFieldAnalytics = withAnalytics(TTextField);
export default TTextField;
